import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import ButtonSecondaryMedium from '../../common/ButtonSecondary/ButtonSecondaryMedium';
import { Icon } from '../../icon/icon';
import ProductCard from '../ProductCard/ProductCard';
import './SectionCustomDesign.scss';
// import Swiper core and required modules
import { Navigation, Scrollbar, A11y, Mousewheel } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSaleProducts } from '../../../store/actions/sale-product.action';
import { Trans, useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import ROUTER from '../../../routers/Routers';
import ButtonIconSolidLarge from '../../common/ButtonIconSolid/ButtonIconSolidLarge';
import ButtonTertiaryMedium from '../../common/ButtonTertiary/ButtonTertiaryMedium';
import { Divider } from 'antd';
import { cn } from '../../../utils/string/cn.utils';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const SectionCustomDesign = () => {
  const { products } = useSelector(state => state.product);

  return (
    <section className="section-custom-design flex lg:px-[80px] lg:py-[60px] py-[32px] md:px-[20px] px-[16px] flex-col items-start lg:gap-[32px] gap-[24px] self-stretch lg:rounded-t-[60px] bg-[#F7F7F7]">
      <div className="flex lg:justify-center items-center self-stretch gap-[8px]">
        <span className="lg:h1 text-headline-small !font-bold lg:text-center text-left">
          <Trans
            i18nKey={
              'Constant.Design it yourself - Easily customize the template All within your budget!'
            }
            components={{
              highlight: <span className="text-primary-primary" />,
              br: <br />,
            }}
          />
        </span>
      </div>
      <div className="flex flex-col items-start self-stretch gap-[24px] max-w-full">
        {products?.data?.map(item => {
          return <RenderSwiperProduct item={item} key={item.id} />;
        })}
      </div>
    </section>
  );
};

export default SectionCustomDesign;

const RenderSwiperProduct = ({ item }) => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { saleProducts } = useSelector(state => state.saleProduct);
  const [offset, setOffset] = useState(0);

  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    if (
      saleProducts.data[item.id]?.total <=
      saleProducts.data[item.id]?.products?.length
    )
      return;
    dispatch(
      fetchSaleProducts({
        productId: item.id,
        saleType: item.type_design === 'normal' ? 'normal' : 'design',
        offset: offset,
        limit: 5,
        country_code,
      })
    ).then(action => {
      if (action.payload?.data?.length) {
        setOffset(prev => prev + action.payload.data.length);
      }
    });
  }, [offset, country_code]);

  useEffect(() => {
    if (item) {
      fetchData();
    }
  }, []);

  if (
    saleProducts.data[item.id]?.isLoading === false &&
    !saleProducts.data[item.id]?.products?.length
  )
    return;
  return (
    <section className="section-products flex flex-col items-start gap-16 self-stretch">
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <div className="flex lg:flex-row flex-col items-start gap-16 self-stretch relative">
          <div className="lg:w-[200px] lg:h-[704px] flex lg:flex-col items-end self-stretch lg:rounded-[16px] gap-0 min-w-[200px] max-h-[577px] overflow-hidden">
            <div className="lg:flex hidden grow self-stretch overflow-hidden justify-center">
              <img
                src={item.column_image_url}
                alt=""
                className="object-cover w-full"
              />
            </div>
            <div className="lg:bg-fills-secondary flex flex-row lg:p-[24px] lg:!flex-col grow lg:justify-center justify-between items-center gap-[24px] self-stretch lg:h-[168px]">
              <div className="flex flex-col justify-center items-center gap-[8px] lg:h-[64px] text-center">
                <span className="lg:text-headline-small text-title-large lg:font-semibold !font-bold">
                  {getValueFromString(item?.name)}
                </span>
              </div>
              <ButtonSecondaryMedium
                preIcon={<Icon.ICArrowOutward />}
                title={t('See all')}
                className={'lg:flex hidden'}
                onClick={() => {
                  navigate(ROUTER.CATEGORY + '/' + item.id);
                }}
              />
              <ButtonTertiaryMedium
                title={t('See all')}
                className={'lg:hidden'}
                onClick={() => {
                  navigate(ROUTER.CATEGORY + '/' + item.id);
                }}
              />
            </div>
          </div>

          <Swiper
            ref={swiperRef}
            modules={[Navigation, A11y, Scrollbar, Mousewheel]}
            spaceBetween={4}
            slidesPerView={'auto'}
            className="ms-0 w-full"
            updateOnWindowResize={true}
            navigation={{
              prevEl: '.custom-swiper-button-prev' + item?.id,
              nextEl: '.custom-swiper-button-next' + item?.id,
            }}
            scrollbar={{
              draggable: true,
              el: '.custom-scrollbar' + item?.id,
              dragClass: 'custom-scrollbar-drag' + item?.id,
            }}
            mousewheel={{
              forceToAxis: true, // chỉ cho cuộn ngang
            }}
            onProgress={(swiper, progress) => {
              if (progress === 1 && !saleProducts.data[item.id]?.isLoading) {
                fetchData();
              }
            }}
          >
            {saleProducts.data[item.id]?.products?.map((product, i) => {
              return (
                <SwiperSlide key={i} className={`w-fit flex-shrink-0`}>
                  <ProductCard
                    onClick={() => {
                      navigate(ROUTER.PRODUCT_DETAIL + '/' + product.id);
                    }}
                    item={{
                      ...product,
                      priceAfter: product.price_after || 0,
                      priceOriginal: product.price_original || 0,

                      images: [
                        ...(product.image_urls?.map(icon => ({ src: icon })) ||
                          []),
                        ...(product.images?.map(icon => ({ src: icon })) || []),
                        { src: product.thumbnail_url },
                      ].filter(item => item.src),
                    }}
                    tags={
                      product.discount_value
                        ? [
                            {
                              label:
                                product.discount_type === 'PERCENT_DISCOUNT'
                                  ? `${product.discount_value}%`
                                  : `${convertForeignCurrency(product.discount_value)}`,
                              className:
                                'bg-primary-secondary py-[4px] px-[8px] rounded-[4px]',
                            },
                          ]
                        : null
                    }
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
          <ButtonIconSolidLarge
            icon={<Icon.ICPrev />}
            className={
              'lg:flex hidden top-1/2 -translate-y-1/2 left-[208px] z-10 absolute disabled:pointer-events-auto custom-swiper-button-prev' +
              item?.id
            }
          />
          <ButtonIconSolidLarge
            icon={<Icon.ICNext />}
            className={cn(
              'lg:flex hidden top-1/2 -translate-y-1/2 -right-[8px] z-10 absolute disabled:pointer-events-auto custom-swiper-button-next' +
                item?.id
            )}
          />
        </div>
        <div
          className={
            'lg:hidden flex justify-end items-center gap-8 self-stretch lg:px-[80px] container-scrollbar' +
            item?.id
          }
        >
          <div
            className={
              'relative w-full h-[4px] bg-transparent rounded-[2px] cursor-pointer transition-all duration-300 ease-in-out overflow-hidden custom-scrollbar' +
              item?.id
            }
          >
            <div
              className={
                'relative bg-fills-tertiary h-[4px] rounded-[2px] transition-all duration-300 ease-in-out cursor-grab active:bg-[#B0B0B0] hover:bg-[#B0B0B0] custom-scrollbar-drag' +
                item?.id
              }
            ></div>
          </div>
          <div className="custom-navigation py-4 px-8 items-center gap-8 rounded-[100px] bg-fills-white">
            <ButtonIconGhostSmall
              icon={<Icon.ICPrev />}
              className={'custom-swiper-button-prev' + item?.id}
            />
            <Divider
              type="vertical"
              style={{ margin: 0, background: '#E6E7E7', height: '24px' }}
            />
            <ButtonIconGhostSmall
              icon={<Icon.ICNext />}
              className={'custom-swiper-button-next' + item?.id}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
